module.exports = __webpack_public_path__ + "static/media/map.747fa698.png";